import type { CityConfig } from "../city-template/types";

export const chesterVaConfig: CityConfig = {
  city: "Chester",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "chester-va",
  route: "/chester-va",
  title: "Emergency Passport Chester, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Chester, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Chester, Chesterfield County, Richmond, and the Tri-Cities area. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Chester, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from Chester, Chesterfield County, or the Richmond suburbs? We help Chester travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Chester%20Virginia%20suburban%20landscape%20along%20the%20Jefferson%20Davis%20Highway%20corridor%2C%20modern%20residential%20neighborhoods%20with%20tree-lined%20streets%20and%20Chesterfield%20County%20shopping%20centers%2C%20the%20Chesterfield%20County%20government%20complex%20visible%20in%20the%20background%2C%20the%20Chester%20Station%20historic%20area%20with%20a%20mix%20of%20old%20and%20new%20architecture%2C%20warm%20afternoon%20light%20with%20green%20lawns%20and%20rolling%20suburban%20terrain%2C%20the%20I-95%20highway%20corridor%20visible%20in%20the%20distance%2C%20professional%20photography%20showcasing%20a%20growing%20Richmond%20suburb%20with%20suburban%20charm%20and%20modern%20retail%20development%2C%20no%20people%20visible%2C%20scenic%20suburban%20landscape%20with%20commercial%20corridors%20and%20residential%20greenery&width=1800&height=700&seq=chester-va-hero-001&orientation=landscape",
  heroImageAlt: "Chester Virginia suburban landscape along Jefferson Davis Highway with Chesterfield County government complex and residential neighborhoods",
  geoPosition: "37.3568;-77.4417",
  geoPlacename: "Chester, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 125 miles north of Chester via I-95",
  },
  nearbyCitiesZips: [
    { name: "Chester", zips: "23831, 23836" },
    { name: "Chesterfield", zips: "23832, 23838" },
    { name: "Midlothian", zips: "23112, 23113, 23114" },
    { name: "Richmond", zips: "23218, 23219, 23220, 23221, 23222, 23223, 23224, 23225, 23226, 23227, 23228, 23229, 23230, 23231, 23233, 23234, 23235, 23236, 23237, 23238, 23242" },
    { name: "Colonial Heights", zips: "23834" },
    { name: "Petersburg", zips: "23803, 23804, 23805, 23806" },
    { name: "Hopewell", zips: "23860" },
    { name: "Fort Lee", zips: "23801" },
    { name: "Matoaca", zips: "23836" },
    { name: "Ettrick", zips: "23803" },
    { name: "Glen Allen", zips: "23058, 23059, 23060" },
    { name: "Short Pump", zips: "23233" },
    { name: "Henrico", zips: "23075, 23228, 23229, 23231, 23233, 23238, 23242, 23255" },
    { name: "Hanover", zips: "23005, 23009, 23015, 23047, 23059, 23069" },
    { name: "Mechanicsville", zips: "23111, 23116" },
    { name: "Prince George", zips: "23875" },
    { name: "Dinwiddie", zips: "23841" },
    { name: "Emporia", zips: "23847" },
    { name: "Ashland", zips: "23005" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from Chesterfield County" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Chesterfield County Hub", desc: "Serving Chester, Midlothian, Richmond, Colonial Heights, and the Tri-Cities area" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Richmond VA passport services", route: "/richmond-va" },
    { name: "Midlothian VA passport services", route: "/midlothian-va" },
    { name: "Colonial Heights VA passport services", route: "/colonial-heights-va" },
    { name: "Petersburg VA passport services", route: "/petersburg-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Chester remotely via secure courier. We do not have a walk-in office in Chester — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Chester and Chesterfield County travelers.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, Maryland 20814",
  fpcOfficeDistance: "Serving all of Chester and Chesterfield County including Midlothian, Richmond, Colonial Heights, Petersburg, Hopewell, Fort Lee, and the Tri-Cities area",
  serviceAreaIntro: "From the suburban corridors of Chester along Jefferson Davis Highway to the quiet neighborhoods of Chesterfield, from the bustling shopping centers near the I-95 interchange to the historic charm of the Chester Station area, from the nearby communities of Midlothian and Glen Allen to the Tri-Cities bustle of Petersburg and Colonial Heights — Fast Passport Center serves every corner of Chester and Chesterfield County. We regularly help travelers from the Richmond suburbs, Fort Lee military families, and the Tri-Cities region get their passports fast.",
  nearbyCitiesIntro: "We serve all Chester neighborhoods and Chesterfield County including Midlothian, Richmond, Colonial Heights, Petersburg, Hopewell, Fort Lee, Matoaca, and Prince George.",
  howItWorksIntro: "Most Chester travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Chester travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Chester and Chesterfield County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Chester? Here are the most common ones we hear from Chesterfield County travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Virginia Dept of Health Vital Records", href: "https://www.vdh.virginia.gov/vital-records/", description: "Official Virginia vital records office in Richmond" },
    { label: "Marriage Licenses — Chesterfield County Circuit Court Clerk", href: "https://www.chesterfield.gov/297/Vital-Records", description: "Chesterfield County Circuit Court Clerk — marriage license issuance" },
    { label: "Divorce Records — Chesterfield County Circuit Court Clerk", href: "https://www.chesterfield.gov/297/Vital-Records", description: "Chesterfield County Circuit Court Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of VDH for online vital record orders" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Chester international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Michelle B.",
      location: "Chester, VA",
      rating: 5,
      text: "My family needed emergency passports for a surprise cruise to the Bahamas with 5 days notice. Fast Passport Center had all five of our passports ready in 4 days. We shipped from the UPS on Jefferson Davis Highway and it was completely seamless. Best service for Chesterfield County families.",
      service: "Emergency Passport",
    },
    {
      name: "Thomas H.",
      location: "Chester, VA",
      rating: 5,
      text: "As a Chester resident, I assumed I'd have to drive to DC or Richmond for expedited passport service. Fast Passport Center proved me wrong. I shipped from my local UPS and had my renewal in 4 days. No road trip, no government lines, no hassle.",
      service: "Passport Renewal",
    },
    {
      name: "Rachel S.",
      location: "Midlothian, VA",
      rating: 5,
      text: "First passport for my son before a school trip to Europe. Fast Passport Center handled the parental consent requirements perfectly and had the passport in 5 days. For Chesterfield County families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "Kevin J.",
      location: "Chesterfield, VA",
      rating: 5,
      text: "Lost my passport 2 days before an important business trip to London. Fast Passport Center had a replacement in my hands in 48 hours. They saved my business trip. Chesterfield County professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "chester-va-1",
      name: "Chester Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "12501 Jefferson Davis Hwy",
      city: "Chester",
      state: "VA",
      zip: "23831",
      phone: "(804) 748-1221",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Chester, along Jefferson Davis Highway",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Chester facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "chester-va-2",
      name: "Midlothian Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "13831 Hull Street Rd",
      city: "Midlothian",
      state: "VA",
      zip: "23112",
      phone: "(804) 744-2011",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Midlothian, north of Chester",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Midlothian and Chesterfield County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "chester-va-3",
      name: "Colonial Heights Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1201 Boulevard",
      city: "Colonial Heights",
      state: "VA",
      zip: "23834",
      phone: "(804) 526-6500",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      distance: "Colonial Heights, south of Chester",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Colonial Heights and Tri-Cities area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "chester-va-4",
      name: "Petersburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 N Sycamore St",
      city: "Petersburg",
      state: "VA",
      zip: "23803",
      phone: "(804) 733-2521",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Petersburg, south of Chester",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Petersburg and Tri-Cities area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "chester-va-5",
      name: "Chesterfield County Clerk",
      type: "County Clerk",
      address: "P.O. Box 125",
      city: "Chesterfield",
      state: "VA",
      zip: "23832",
      phone: "(804) 748-1241",
      hours: "Mon–Fri: 8:30 AM – 5:00 PM",
      distance: "Chesterfield, near Chester",
      website: "https://www.chesterfield.gov",
      websiteLabel: "Chesterfield County",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
    {
      id: "chester-va-6",
      name: "Fort Lee ID Card Office",
      type: "Military Facility",
      address: "Fort Lee, Bldg 9020",
      city: "Fort Lee",
      state: "VA",
      zip: "23801",
      phone: "(804) 734-4200",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM",
      distance: "Fort Lee, near Chester",
      website: "https://home.army.mil/lee",
      websiteLabel: "Fort Lee",
      notes: "Military ID and passport services for active duty and dependents. Appointment required. Call ahead for current passport acceptance hours.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2+ hour drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Who Can Use It", agency: "Life-or-death emergencies only — proof required", fpc: "All travelers — urgent, expedited, or planned" },
    { feature: "Cost vs Resellers", agency: "Government fee only — no courier service", fpc: "30–100% less than FedEx, Staples, and other resellers" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Chester photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Chesterfield County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Chester applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Chester families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Chester travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Chester or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Chester address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Chester before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Chester for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from Chesterfield County and the Richmond suburbs." },
    { q: "How fast can I renew my passport in Chester?", a: "Fast Passport Center offers fast passport renewal in Chester in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Chester?", a: "The nearest regional passport agency to Chester is the Washington Passport Agency, located approximately 125 miles north in downtown Washington, DC. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Chester." },
    { q: "Can I get a same-day passport appointment near Chester?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Chester residents." },
    { q: "Can I expedite a child passport in Chester?", a: "Yes. Fast Passport Center expedites child passports in Chester for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Chester and Chesterfield County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Chester with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Chester?", a: "With Fast Passport Center's emergency courier service, Chester travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Chester?", a: "Popular options include the Chester Post Office (23831), Midlothian Post Office (23112), Colonial Heights Post Office (23834), and Petersburg Post Office (23803). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in Midlothian, Chesterfield, or Colonial Heights?", a: "We serve all of Chesterfield County including Midlothian, Chesterfield, Colonial Heights, Petersburg, and Hopewell. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Chester?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Chester", address: "12300 Jefferson Davis Hwy, Chester, VA 23831", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "Walmart — Chester", address: "1200 Walmart Way, Chester, VA 23831", hours: "Mon-Sun: 6AM-11PM", website: "https://www.walmart.com/cp/passport-photos/1055304", websiteLabel: "Walmart Photo" },
    { name: "CVS Pharmacy — Midlothian", address: "13901 Midlothian Tpke, Midlothian, VA 23113", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "Walgreens — Colonial Heights", address: "1000 Southpark Blvd, Colonial Heights, VA 23834", hours: "Mon-Sun: 7AM-11PM", website: "https://www.walgreens.com/photo/passport-photo", websiteLabel: "Walgreens Photo" },
    { name: "CVS Pharmacy — Petersburg", address: "2050 S Crater Rd, Petersburg, VA 23805", hours: "Mon-Sun: 8AM-10PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "Walmart — Colonial Heights", address: "350 Sparkleberry Rd, Colonial Heights, VA 23834", hours: "Mon-Sun: 6AM-11PM", website: "https://www.walmart.com/cp/passport-photos/1055304", websiteLabel: "Walmart Photo" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Chester",
      address: "12801 Jefferson Davis Hwy, Chester, VA 23831",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Colonial Heights",
      address: "201 Temple Ave, Colonial Heights, VA 23834",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Midlothian",
      address: "13501 Midlothian Tpke, Midlothian, VA 23113",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "Approximately 18 miles north of Chester",
      address: "1 Richard E. Byrd Terminal Dr, Richmond, VA 23250",
      note: "The closest major airport. Domestic and limited international flights. Accessible via I-95.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: true,
    },
    {
      code: "PHF",
      name: "Newport News/Williamsburg International Airport",
      distance: "Approximately 60 miles east of Chester",
      address: "900 Bland Blvd, Newport News, VA 23602",
      note: "Regional airport. Accessible via I-64.",
      flightUrl: "https://www.flyphf.com/",
      flightLabel: "PHF Airport",
      featured: false,
    },
    {
      code: "ORF",
      name: "Norfolk International Airport",
      distance: "Approximately 80 miles southeast of Chester",
      address: "2200 Norview Ave, Norfolk, VA 23518",
      note: "Regional hub for Hampton Roads. Accessible via I-95 and I-64.",
      flightUrl: "https://www.norfolkairport.com/",
      flightLabel: "ORF Airport",
      featured: false,
    },
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "Approximately 125 miles north of Chester",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Major international hub for DC metro area. Accessible via I-95.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
  ],
};